/**
 * Shared surface styles for text inputs and selects.
 * Keep this as the single source of truth for field borders/focus rings.
 */
export const FORM_CONTROL_CLASS =
  'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-900 outline-none focus-visible:border-primary-500 focus-visible:ring-2 focus-visible:ring-primary-500 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400';
